import Dexie, { type EntityTable, type Table } from 'dexie'
import type {
  AppMetadata,
  DailyNewsCache,
  InspirationTag,
  LocalDevice,
  LocalUser,
  LocalWorkspace,
  Note,
  PendingOperation,
  PracticeRecord,
  RecurringTodo,
  ReviewLog,
  StudySession,
  SyncConflict,
  SyncState,
  Todo,
  UserSettings,
  WorkspaceMembership,
} from '@/domain/types'

export class StudyToolDatabase extends Dexie {
  localUsers!: EntityTable<LocalUser, 'id'>
  localWorkspaces!: EntityTable<LocalWorkspace, 'id'>
  workspaceMemberships!: Table<WorkspaceMembership, [string, string]>
  localDevices!: EntityTable<LocalDevice, 'id'>
  studySessions!: EntityTable<StudySession, 'id'>
  notes!: EntityTable<Note, 'id'>
  todos!: EntityTable<Todo, 'id'>
  recurringTodos!: EntityTable<RecurringTodo, 'id'>
  practiceRecords!: EntityTable<PracticeRecord, 'id'>
  inspirationTags!: EntityTable<InspirationTag, 'id'>
  userSettings!: EntityTable<UserSettings, 'id'>
  pendingOperations!: EntityTable<PendingOperation, 'operationId'>
  syncState!: EntityTable<SyncState, 'workspaceId'>
  conflicts!: EntityTable<SyncConflict, 'id'>
  appMetadata!: EntityTable<AppMetadata, 'key'>
  dailyNews!: EntityTable<DailyNewsCache, 'date'>
  reviewLogs!: EntityTable<ReviewLog, 'id'>

  constructor() {
    super('anshang-study-tool')
    this.version(1).stores({
      localUsers: 'id, role',
      localWorkspaces: 'id, ownerUserId, kind',
      workspaceMemberships: '[workspaceId+userId], userId, workspaceId',
      localDevices: 'id, userId, revokedAtMs',
      studySessions: 'id, workspaceId, ownerUserId, startedAtMs, updatedAtMs, deletedAtMs, status',
      notes: 'id, workspaceId, ownerUserId, category, updatedAtMs, deletedAtMs, nextReviewAtMs, *tags',
      todos: 'id, workspaceId, ownerUserId, taskDate, updatedAtMs, deletedAtMs, completed',
      recurringTodos: 'id, workspaceId, ownerUserId, updatedAtMs, deletedAtMs, active',
      practiceRecords: 'id, workspaceId, ownerUserId, module, updatedAtMs, deletedAtMs',
      inspirationTags: 'id, workspaceId, ownerUserId, [workspaceId+module], name, deletedAtMs',
      userSettings: 'id, workspaceId, ownerUserId, updatedAtMs',
      pendingOperations: 'operationId, workspaceId, entityType, entityId, nextRetryAtMs, createdAtMs',
      syncState: 'workspaceId, status, lastSuccessAtMs',
      conflicts: 'id, workspaceId, entityType, entityId, resolvedAtMs, detectedAtMs',
      appMetadata: 'key, updatedAtMs',
      dailyNews: 'date, generatedAtMs',
      reviewLogs: 'id, noteId, workspaceId, reviewedAt',
    })
  }
}

export const localDb = new StudyToolDatabase()
